import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import Course from "../../models/course.model";
import Enrollment from "../../models/enrollment.model";

@Component({
  selector: "ngx-view-course",
  styleUrls: ["./view-course.component.scss"],
  templateUrl: "./view-course.component.html",
})
export class ViewCourseComponent implements OnInit {
  @Input() course: Course;
  @Input() mode?: string;
  @Input() courseId?: string;
  @Input() enrolId?: string;
  @Input() enrol?: Enrollment;
  @Output() onRedirect: EventEmitter<any> = new EventEmitter();

  imageURL =
    "https://kasoft-learning.s3.ap-southeast-1.amazonaws.com/Courses/cover-default.png";

  loading = false;
  flipped = false;
  value = 0;

  constructor(private router: Router) {}

  get status() {
    if (this.value <= 25) {
      return "danger";
    } else if (this.value <= 50) {
      return "warning";
    } else if (this.value <= 75) {
      return "info";
    } else {
      return "success";
    }
  }

  ngOnInit(): void {
    if (this.course.coverUrl != "") this.imageURL = this.course.coverUrl;

    if (
      this.enrol &&
      this.enrol.noLectureFinished > 0 &&
      this.course.noLecture > 0
    ) {
      this.value = Math.round(
        (this.enrol.noLectureFinished / this.course.noLecture) * 100
      );
    }

    this.value = this.enrol && this.enrol.finished ? 100 : this.value;
  }

  toggleView() {
    this.flipped = !this.flipped;
  }

  onClick() {
    this.onRedirect.emit(true);

    if (this.mode === "tutor") {
      this.router.navigateByUrl(`/tutor/courses/${this.course.id}`);
    } else if (this.mode === "student") {
      this.router.navigateByUrl(
        `/student/courses/${this.enrol.id}/${this.enrol.courseId}`
      );
    } else {
      this.router.navigateByUrl(`/course/${this.course.id}`);
    }
  }

  onFrontClick() {
    if (this.mode === "tutor" || this.mode === "student") {
      this.onClick();
    } else {
      this.toggleView();
    }
  }
}
